var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { GenericFacetComponent } from "../generic-facet/generic-facet.component";
var AccessibilityFacetComponent = /** @class */ (function (_super) {
    __extends(AccessibilityFacetComponent, _super);
    function AccessibilityFacetComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.facetName = "accessibility";
        _this.adaptationTypesOptions = [];
        _this.adaptationTypesOrder = [
            "Audio Description",
            "Descriptive Video",
            "Caption",
            "Transcript",
        ];
        _this.controlFlexibilityOptions = [];
        _this.controlFlexibilityOrder = [
            "Full Keyboard Control",
            "Full Mouse Control",
        ];
        return _this;
    }
    AccessibilityFacetComponent.prototype.setOptions = function (options) {
        var _this = this;
        _super.prototype.setOptions.call(this, options);
        var adaptationTypesOptions = options.filter(function (facet) { return _this.adaptationTypesOrder.indexOf(facet.label) !== -1; });
        adaptationTypesOptions.sort(function (a, b) {
            return (_this.adaptationTypesOrder.indexOf(a.label) -
                _this.adaptationTypesOrder.indexOf(b.label));
        });
        this.adaptationTypesOptions = adaptationTypesOptions;
        var controlFlexibilityOptions = options.filter(function (facet) { return _this.controlFlexibilityOrder.indexOf(facet.label) !== -1; });
        controlFlexibilityOptions.sort(function (a, b) {
            return (_this.controlFlexibilityOrder.indexOf(a.label) -
                _this.controlFlexibilityOrder.indexOf(b.label));
        });
        this.controlFlexibilityOptions = controlFlexibilityOptions;
    };
    return AccessibilityFacetComponent;
}(GenericFacetComponent));
export { AccessibilityFacetComponent };
